// This is a very simple event event library written for the legacy
// javascript.  It uses a timer to consolidate network calls.
//
// Note: There is no retry logic.
//
// When we re-implement this for the new javascript we should include
// an event to make sure we flush the queue before the user leaves the
// page.  Alternatly, we might use local storage.

var LEGACY_EVENTS = [];
var LEGACY_EVENT_TIMER = null;

const legacyEBPublish = function (event, data, flush) {
  var e = { event: event };
  if (data) {
    e['data'] = data;
  }

  LEGACY_EVENTS.push(e);

  clearTimeout(LEGACY_EVENT_TIMER);
  if (flush) {
    legacyEBFlush();
  } else {
    LEGACY_EVENT_TIMER = setTimeout(legacyEBFlush, 150); // 150 is arbitrary
  }
};

function legacyEBFlush() {
  if (LEGACY_EVENTS.length == 0) {
    return;
  }

  var events = LEGACY_EVENTS;
  LEGACY_EVENTS = [];

  const init = {
    method: 'POST',
    body: JSON.stringify(events),
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'User-Agent': 'Brainscape Web',
      'X-Brainscape-EventKey': '6d67869e-e3d7-4eff-8c4c-5b38d6dea150',
      'X-Brainscape-TZO': new Date().getTimezoneOffset().toString(),
    },
  };
  return fetch('/api/events', init)
    .then((rs) => {
      if (rs.ok) return;

      console.error('Error sending events:', rs.status, rs.statusText);
    })
    .catch((err) => {
      console.error('Error sending events:', err);
    });
}

export default legacyEBPublish;
